import { create } from "zustand";
import * as api from "../services/inspections";

export const useNatravStore = create((set) => ({
  available: null,

  fetchStatus: async () => {
    const result = await api.getTunnelStatus();
    if (result.data) {
      set({ available: result.data.available });
    }
    return result;
  },
}));
